import { PrimaryButton } from '@designsforhealth/dfh-react-components'
import styled from 'styled-components'

import { Checkbox as GlobalCheckbox } from '../../../../form/Checkbox'
import GlobalLink from '../../../../global/Link'

export const Form = styled.form`
  max-width: 350px;
  margin-bottom: 40px;
`

export const Checkbox = styled(GlobalCheckbox)`
  &:last-of-type {
    margin-bottom: 31px;
  }
`

export const LabelSpan = styled.span`
  font-size: 14px;
  line-height: 16px;
`

export const SubmitOrCancel = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 29px;
  margin-bottom: 20px;
  padding-right: 31px;
`

export const SubmitButton = styled(PrimaryButton)`
  min-width: 10em;
`

export const Link = styled(GlobalLink)`
  &:visited {
    color: ${({ theme }) => theme.colors.grayscale.black};
  }
`
